/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from "react";
import TableTemplate from "./Table";
import CardLayout from "../Cards/CardLayout";
import { formatDateForDisplay } from "../../utils/formatters";
import { FiMoreVertical } from "react-icons/fi";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import CardError from "../feedBacks/CardError";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import { IUser } from "../../utils/interfaces";
import AddEmployeeModal from "../Modals/AddEmployee";
import { IconWrapper } from "../../customHooks/useIcon";
import { ROWS_PER_PAGE } from "../../utils/constants";
import ChangeUserPasswordModal from "../Modals/ChangePasswordModal";

const columns = [
  "Users",
  "Company",
  "Employee ID",
  "Email address",
  "Department",
  "Date Joined",
];

const UsersTable = ({ company_id }: { company_id?: string }) => {
    const [page, setPage] = React.useState(1);
    const [isNextPageLoading, setIsNextPageLoading] = React.useState(false);
  // const ROWS_PER_PAGE = 7;
  const { data, isLoading:isDataLoading, error, refetch }: any = useFetchData(
    ['/users', 'fetchAllUsers', company_id],
    "/users",
    {
      page,
      page_size: ROWS_PER_PAGE,
      company_id,
    },
    // @ts-ignore
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      staleTime: 0, // Consider data immediately stale to encourage refreshes
    }
  );
   const isLoading = isDataLoading || isNextPageLoading;
  const tableData =  data?.results.map((item: IUser) => ({
      'User ID': item.id,
      Users: `${item.first_name} ${item.last_name}`,
      Company: item.company.name,
      "Employee ID": item.employee_id,
      "Email address": item.email,
      Department: item.access_level,
      "Date Joined": formatDateForDisplay(item.created_at),
      ...item
    })) ?? []


  const handlePageChange = (newPage: number) => {
    setIsNextPageLoading(true);
    setPage(newPage);
  };
  const [editUserModal, setEditUserModal] = React.useState(false);
  const [changeUserPasswordModal, setChangeUserPasswordModal] = React.useState(false);
  const [userDetails, setUserDetails] = React.useState<IUser | null>(null);
    useEffect(() => {
      refetch().finally(() => {
        setIsNextPageLoading(false);
      });
    }, [page, refetch]);
  return (
    <CardLayout
      title=""
      className="lg:min-w-[550px] flex-1 flex flex-col !justify-center !items-start"
    >
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        <CardError message="Error fetching users" />
      ) : !tableData || tableData.length === 0 ? (
        <NoContent message="No user found" />
      ) : (
        <TableTemplate
          data={tableData}
          columns={columns}
          extraAction={true}
          extraActionIcon={<IconWrapper icon={FiMoreVertical} />}
          actionType="showPopUp"
          extraActionPopUpContent={(row: IUser) => (
            <div className="flex max-w-[150px] flex-col !text-center items-start justify-center ">
              <span
                onClick={() => {
                  setEditUserModal(true);
                  setUserDetails(row);
                }}
                className="w-full flex items-center justify-center cursor-pointer hover:bg-primary-blackLighter2 hover:rounded-full hover:px-4 hover:py-1"
              >
                Modify
              </span>
              <span
                onClick={() => {
                  setChangeUserPasswordModal(true);
                  setUserDetails(row);
                }}
                className="w-full flex items-center justify-center cursor-pointer hover:bg-primary-blackLighter2 hover:rounded-full hover:px-4 hover:py-1"
              >
                Change Password
              </span>
              <span className=" p-1 bg-red-500  text-white w-full flex items-center justify-center cursor-pointer rounded-full">
                Delete
              </span>
            </div>
          )}
          totalCount={data?.total_results || 0}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={ROWS_PER_PAGE}
        />
      )}
      <AddEmployeeModal
        isModalOpen={editUserModal}
        closeModal={() => setEditUserModal(false)}
        enableOutsideClick={false}
        type="edit"
        data={userDetails as IUser}
      />
      <ChangeUserPasswordModal
        isModalOpen={changeUserPasswordModal}
        closeModal={() => setChangeUserPasswordModal(false)}
        enableOutsideClick={false}
        data={userDetails as IUser}
      />
    </CardLayout>
  );
};

export default UsersTable;
